import React from 'react';
import { Button } from '../../../../../components/ui/Button';
import { AppIcon } from '../../../../../components/icons/AppIcon';

interface UploadStepProps {
    onFileSelect: (e: React.ChangeEvent<HTMLInputElement>) => void;
    isParsing: boolean;
}

export const UploadStep: React.FC<UploadStepProps> = ({ onFileSelect, isParsing }) => {
    return (
        <div className="flex flex-col items-center justify-center rounded-lg border-2 border-dashed border-border bg-surface-subtle p-s8 transition-colors hover:bg-surface-2">
            <AppIcon name="upload" className="mb-s4 size-12 text-muted" aria-hidden />
            <p className="mb-s2 font-medium text-default">Clique para selecionar</p>
            <p className="mb-s6 text-sm text-muted">Suporta CSV, XLS, XLSX</p>

            <input
                type="file"
                id="file-upload"
                name="file-upload"
                className="hidden"
                accept=".csv,.xls,.xlsx,.txt"
                onChange={onFileSelect}
                disabled={isParsing}
            />

            <Button
                type="button"
                onClick={() => document.getElementById('file-upload')?.click()}
                disabled={isParsing}
                className="min-h-11 touch-manipulation"
            >
                {isParsing ? 'Lendo arquivo...' : 'Selecionar Arquivo'}
            </Button>
        </div>
    );
};
